<template>
    <div class="profile-details w-100">
        <b-row class="skeleton" v-if="isLoading">
            <b-col lg="4" class="content">
                <div></div>
                <div></div>
                <div class="smaller"></div>
                <div class="smaller"></div>
            </b-col>
            <b-col lg="4" class="content">
                <div class="smaller"></div>
                <div></div>
            </b-col>
        </b-row>
        <b-row v-else-if="theReturn">
            <b-col lg="4" class="content">
                <table class="table details table-borderless min-th">
                    <tbody>
                        <tr>
                            <th>Date:</th>
                            <td>
                                {{ _carbonDateDisplay(theReturn.return_date) }}
                            </td>
                        </tr>
                        <tr>
                            <th>Client:</th>
                            <td>
                                <client-name
                                    v-if="clientDetails"
                                    :client="clientDetails"
                                />
                            </td>
                        </tr>
                        <tr>
                            <th>Amount:</th>
                            <td>
                                <span>
                                    {{
                                        _toCurrency(
                                            theReturn.return_amount || 0
                                        )
                                    }}
                                </span>
                            </td>
                        </tr>
                        <tr>
                            <th>Notes:</th>
                            <td>{{ theReturn.note }}</td>
                        </tr>
                    </tbody>
                </table>
            </b-col>
            <b-col lg="4" class="content">
                <table class="table details table-borderless">
                    <tbody>
                        <tr>
                            <th>Credit Issued:</th>
                            <td>
                                <div v-if="fullDetails.credit">
                                    {{ _toCurrency(fullDetails.credit.amount) }}
                                    (<strong
                                        class="text-nowrap"
                                        :class="{
                                            'text-primary cursor-pointer': _hasAccess(
                                                'billing.credit.update'
                                            )
                                        }"
                                        @click="
                                            showEditCredit(
                                                theReturn,
                                                fullDetails.credit,
                                                _hasAccess(
                                                    'billing.credit.update'
                                                )
                                            )
                                        "
                                        >{{ fullDetails.credit.name }}</strong
                                    >)
                                </div>
                                <span v-else>{{ _toCurrency(0) }}</span>
                            </td>
                        </tr>
                        <tr>
                            <th>Refund Issued:</th>
                            <td>
                                <div v-if="fullDetails.refunds.length > 0">
                                    {{
                                        _toCurrency(
                                            getRefundAmount(fullDetails.refunds)
                                        )
                                    }}
                                    (<span
                                        v-for="(refund,
                                        indexRefund) in fullDetails.refunds"
                                        :key="refund.id"
                                    >
                                        <strong
                                            class="text-nowrap"
                                            :class="{
                                                'text-primary cursor-pointer': _hasAccess(
                                                    'billing.refund.update'
                                                )
                                            }"
                                            @click="
                                                showEditRefund(
                                                    theReturn,
                                                    refund,
                                                    _hasAccess(
                                                        'billing.refund.update'
                                                    )
                                                )
                                            "
                                            >{{ refund.name }}</strong
                                        >
                                        <span
                                            v-if="
                                                indexRefund !=
                                                fullDetails.refunds.length - 1
                                            "
                                            >,
                                        </span> </span
                                    >)
                                </div>
                                <span v-else>{{ _toCurrency(0) }}</span>
                            </td>
                        </tr>
                        <tr v-if="theReturn.status == 1">
                            <th>Post Date:</th>
                            <td>
                                {{ _carbonDateDisplay(theReturn.post_date) }}
                            </td>
                        </tr>
                    </tbody>
                </table>
            </b-col>
        </b-row>
        <credit-edit-modal
            ref="creditEditModal"
            modalId="creditEditModal"
            ok-title="Save"
            modal-ref="creditEditModal"
            @reload="refreshPage"
        />
        <refund-edit-modal
            modal-ref="refundEditModal"
            ref="refundEditModal"
            :refund="selectedRefund"
            :client-name="selectedClientname"
            @reload="refreshPage"
        />
    </div>
</template>
<style type="text/css" scoped>
.table.details tbody tr th {
    width: 150px;
}
</style>
<script>
/**
 * @name ReturnDetailsDisplay
 * @description Displaying details of return
 * @see apps/application/views/staff/billing/return/return/view.php
 */
import { forEach } from "lodash";

export default {
    components: {
        ClientName: () => import("@/components/commons/client-name"),
        RefundEditModal: () =>
            import("@/components/client-refunds/refund-edit"),
        CreditEditModal: () =>
            import("@/components/billing-credit/credit-edit-modal")
    },
    data() {
        return {
            isRendered: false,
            activeTabIndex: 0,
            selectedRefund: {},
            selectedClientname: null
        };
    },
    computed: {
        isLoading() {
            return this.$store.getters["returnDetails/isLoading"];
        },
        theReturn() {
            return this.$store.getters["returnDetails/returnDetails"];
        },
        fullDetails() {
            return this.$store.getters["returnDetails/fullDetails"];
        },
        clientDetails() {
            let theReturn = this.$store.getters["returnDetails/returnDetails"];
            let client =
                theReturn && theReturn.client ? theReturn.client : null;

            if (client) {
                client.isactive = client.single_business_actor
                    ? client.single_business_actor.isactive
                    : false;
            }

            return client;
        }
    },
    watch: {
        routeParam() {}
    },
    mounted() {},
    methods: {
        async getDetails() {},
        openModal() {},
        action() {},
        getRefundAmount(refunds) {
            let total = 0;
            forEach(refunds, function (value) {
                total += value.amount;
            });

            return total;
        },
        showEditCredit(returned, credit, canEdit) {
            if (canEdit) {
                credit.client_id = returned.client.id;
                credit.clientLabel = returned.client.label;
                this.$refs.creditEditModal.open(credit);
            }
        },
        showEditRefund(returned, refund, canEdit) {
            if (canEdit) {
                this.selectedClientname = returned.client.label;
                this.selectedRefund = refund;
                this.selectedRefund.client = returned.client;
                this.selectedRefund.isHasReeturn = true;
                this.$refs.refundEditModal.open();
            }
        },
        refreshPage() {
            this.$root.$emit("refresh-return-page");
        }
    }
};
</script>
